<template>
  <div class="modalHabilitacao" v-show="abreFecha">
    <div class="modal_extra">
      <div class="modal_extra-header">TIPOS DE HABILITAÇÕES ESPECIAIS</div>
      <div class="section-info">
        <section class="modal_extra-descricao">
          <div class="menu_info">
            <span class="span_infos" v-for="(vistoria, id) in sortedInfo"
                  :key="id">
              <section
                class="section_menu"
                :class="{'section_menu_selecionado':select_info[id]}"
                @click="selectInfo(id, true)"
              >
                {{ vistoria.nm }}
              </section>
            </span>
          </div>
          <div class="desc_info">
            <span class="span_infos_desc" v-for="(vistoria, id) in sortedInfo"
                  :key="id">
              <section class="section_decricao"
                       v-show="select_info[id]"
              >
                <span v-html="vistoria.nm_mensagem || 'Você não possui a habilitação necessária para dar lances neste lote.'"></span>
                <span>Link para anexar o documento no cadastro:</span>
                <a href="/usuario?pg=1#/documentos/editar-dados">Redirecionar</a>
              </section>
            </span>
          </div>
        </section>
      </div>
      <div>

      </div>
      <div class="modal_extra-footer"
           @click.prevent="fecharModalHabilitacao"
           title="clique aqui para fechar o modal.">
        FECHAR
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalHAbilitacaoExtra',
  props: ['info', 'abreFecha'],
  data() {
    return {
      desc_liberacao_extra: '',
      select_info: {},
    }
  },
  methods: {
    fecharModalHabilitacao() {
      this.$emit('fechaModalLiberacaoExtra', false)
    },
    selectInfo(id, value) {
      this.select_info = Object.assign({}, {[id]: value});
    },
  },
  created() {
    this.selectInfo(0, true)
  },
  computed: {
    sortedInfo() {
      if (!this.info || this.info.length === 0) {
        return [];
      }

      return this.info
        .filter(item => item.nm && typeof item.nm === 'string')
        .slice()
        .sort((a, b) => a.nm.localeCompare(b.nm));
    }
  },
  watch: {
    abreFecha(val) {
      if (val && this.sortedInfo.length > 0) {
        this.selectInfo(0, true);
      }
    },
    info: {
      handler() {
        if (this.abreFecha && this.sortedInfo.length > 0) {
          this.selectInfo(0, true);
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.menu_info {
  width: 30%;
  cursor: pointer;
}

.desc_info {
  width: 70%;
  max-height: 300px;
  overflow-y: scroll;
}

section.section_menu {
  width: 100%;
  background: #f2f2f2;
  padding: 15px 10px;
  border-bottom: 0.5px solid;
  font-size: 1rem !important;
  text-transform: uppercase;
}

.selecionado {
  border-left: 6px solid !important;
  background: #b2b2b2 !important;
}

.section_menu_selecionado {
  font-weight: 900;
  border-left: 3px solid #4b4b4b;
  color: #575757;
}

span.span_infos {
  display: flex;
  flex-direction: row;
}

section.section_decricao {
  text-align: justify;
  padding: 5px 20px;
  width: 100%;
  height: 100%;
  min-height: 300px;
}

.ver {
  display: block;
}

.none {
  display: none !important;
}

span strong a {
  text-decoration: none;
}

.modalHabilitacao {
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000;
  background: rgba(68, 68, 68, 0.04);
  -webkit-backdrop-filter: blur(1px);
  backdrop-filter: blur(1px);
}

.modal_extra {
  overflow: hidden;
  margin: auto;
  max-width: 650px;
  width: 50%;
  max-height: fit-content;
  background: #fff;
  border-radius: 5px;
  box-shadow: 4px 7px 5px rgba(141, 130, 130, 0.07);
}

.modal_extra-header {
  text-align: center;
  padding: 10px;
  color: white;
  font-weight: 800;
  background: #959595;
  border-radius: 5px 5px 0 0;
}

.section-info {
  display: flex;
  width: 100%;
  height: 84%;
  border-radius: 19px;
}

.li-titulo {
  font-size: 12px;
  display: flex;
}

ul.ul-modal-extra {
  display: flex;
  flex-direction: column;
}

li.li-titulo {
  cursor: pointer;
  width: 200px !important;
  padding: 10px 0px;
  border-bottom: 1px solid #9e9e9e;
}

li.li-titulo:hover {
  transition: 0.3s;
  border-left: 6px solid #9e9e9e;
  background: #eeebeb;
}

li.li-titulo:active {
  border-left: 6px solid #9e9e9e;
}

.activeTextModal {
  border-left: 6px solid #9e9e9e;
  background: #eeebeb;
}

section.modal_extra-descricao {
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.modal_extra-footer {
  width: 100%;
  margin: auto;
  padding: 5px;
  color: #575757;
  font-size: 18px;
  font-weight: 900;
  text-align: center;
  cursor: pointer;
  border-top: 1px solid #0000001c;
}

.modal_extra-footer:hover {
  background: rgba(171, 164, 164, 0.15);
}

@media (max-width: 551px ) {
  .modal_extra {
    margin-top: 10rem;
    width: 95%;
    height: 500px !important;
  }

  section.section_menu {
    padding: 10px;
    font-size: 10px;
  }

  .modal_extra-footer {
    width: 100%;
    padding: 0;
    font-size: 14px;
  }

  .desc_info {
    overflow: auto;
  }

  .section-info {
    height: 86%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalHAbilitacaoExtra.vue